export default __webpack_public_path__ + "static/media/monitor.252ee091.svg";